import React, { useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody } from "reactstrap";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { HiOutlineTrash } from "react-icons/hi";
import { FiEdit2 } from "react-icons/fi";
import axios, { get } from "axios";
import { ToastContainer, toast } from "react-toastify";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import config from "../../../../config";
import Breadcrumbs from "../../../Helper/Breadcrumbs";

const TestimonialTable = () => {
  const history = useHistory();
  const tokenKey = {
    headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") },
  };

  let breadcrumbData = [
    { title: "seobook", href: "/seobook" },
    { title: "Testimonials", href: "#" },
  ];

  const toastAttr = {
    theme: "colored",
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    get(config.service + "/masters/testimonials/", tokenKey)
      .then((res) => {
        setTableData(res.data.results || []);
        setTotalCount(res.data.count || 0);
      })
      .catch((err) => {
        if (err.response?.status === 401) window.location.href = "/";
      });
  };

  const deleteRow = (row) => {
    if (window.confirm("Are you sure you want to delete this testimonial?")) {
      axios
        .delete(
          config.service + "/masters/testimonials/" + row.id + "/",
          tokenKey
        )
        .then(() => fetchData())
        .catch(() => toast.error("Deletion Failed", toastAttr));
    }
  };

  const renderForm = (row) => {
    history.push({
      pathname: "/seobook/testimonialform",
      state: row ? { id: row.id, editMode: true } : {},
    });
  };

  const cols = [
    {
      dataField: "name",
      text: "Name",
      headerStyle: { width: "200px" },
    },
    {
      dataField: "content",
      text: "Testimonial",
      headerStyle: { width: "450px" },
      formatter: (cell) => (
        <div
          style={{
            maxWidth: "450px",
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.4",
          }}
        >
          {cell}
        </div>
      ),
    },
    {
      dataField: "rating",
      text: "Rating",
      headerStyle: { width: "80px" },
    },
    {
      dataField: "id",
      text: "Actions",
      headerStyle: { width: "120px" },
      formatter: (cell, row) => (
        <div className="tableActions">
          <FiEdit2 title="Edit" onClick={() => renderForm(row)} />
          <HiOutlineTrash title="Delete" onClick={() => deleteRow(row)} />
        </div>
      ),
    },
  ];

  const paginationOptions = paginationFactory({
    sizePerPage: 10,
    paginationSize: 3,
    hideSizePerPage: true,
    totalSize: totalCount,
    hidePageListOnlyOnePage: true,
  });

  return (
    <Container>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <div className="card__title pageNav">
                <Breadcrumbs data={breadcrumbData} />
              </div>

              <div className="formBtnsDiv mb-3">
                <Button variant="primary" onClick={() => renderForm()}>
                  Create Testimonial
                </Button>
              </div>

              <BootstrapTable
                bootstrap4
                wrapperClasses="table-responsive"
                keyField="id"
                data={tableData}
                columns={cols}
                hover
                noDataIndication="No testimonials found"
                pagination={paginationOptions}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <ToastContainer {...toastAttr} />
    </Container>
  );
};

export default TestimonialTable;
